import React from 'react'
import './User_SetNameState.css'
import '../UserPanel.css'
import agent from "../../../agent";

class User_ValuesState extends React.Component {
  setValue(index, text) {
    let values = this.props.values;
    values[index] = text;
    this.props.updateValues(values);
  }

  sendValues() {
    agent.Game.setValues(this.props.team.uuid, {teamValues: this.props.values}, resp => {
      console.log(resp)
    });
  }

  render() {
    let mainStyle = {
      "paddingTop": "100px",
      "paddingLeft": "100px",
      "width": "1400px",
      "height": "281px",
      "display": "flex",
      "flexDirection": "column",
      "justifyContent": "space-between",
      "alignItems": "flex-start"
    };
    let textStyle = {
      "width": "100%",
      "height": "80px",
      "fontFamily": "Mont",
      "fontSize": "30px",
      "textAlign": "left",
      "paddingTop": "20px"
    }
    let inputStyle = {
      width: "300px", height: "30px", marginTop: "20px", marginRight: "20px"
    }

    const values = [0, 1, 2, 3, 4];
    return <div style={mainStyle}>
      <div className='user-header-text'>Ценности команды</div>
      <div style={textStyle}>Обсудите и запишите ценности команды. <br/>
        По готовности сообщите преподавателю.
      </div>

      <div style={{display: "flex"}}>
        {values.map((el, i) => {
          const theValue = {};
          const isActive = document.activeElement === document.querySelector('.inp-' + i);
          const paramName = isActive ? 'defaultValue' : 'value';
          theValue[paramName] = this.props.values[i];

          return <div key={'value-' + i} className='user-panel-container-input' style={inputStyle}>
                    <textarea
                      className={"user-panel-input-field inp-" + i}
                      placeholder={`Ценность ${i + 1}`}
                      onInput={ev => this.setValue(i, ev.currentTarget.value)}
                      onKeyDown={(ev) => {
                        if (ev.code === 'Enter') this.sendValues();
                      }}
                      onBlur={this.sendValues.bind(this)}
                      {...theValue}
                    />
          </div>
        })}
      </div>

    </div>
  }
}

export default User_ValuesState;
